export default __webpack_public_path__ + "static/media/news (2).ac64a6c8.webp";